import { QUERY_GET_FACTORY_BRANCHES } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactoryBranches = baseThunk(`factoryBranches/getBranches`, QUERY_GET_FACTORY_BRANCHES, "GET")
